import "./tableResultsSimulator.sass";

/**
 * Componente que muestra la tabla de resultados finales del simulador
 * Renderiza las posiciones de los equipos con colores diferenciados por zona de clasificación
*/
export default function TableResultsSimulator({ results }) {
  // Validación: solo renderiza si existen los datos necesarios
  if (!results || !results.finalStandings) return null;

  return (
    <div className="tabla-resultados">
      <h3>Tabla General de Resultados</h3>
      <table className="standings-table">
        {/* Encabezados de la tabla con abreviaciones estándar */}
        <thead>
          <tr>
            <th>Pos</th>
            <th>Club</th>
            <th>JJ</th>
            <th>JG</th>
            <th>JE</th>
            <th>JP</th>
            <th>GF</th>
            <th>GC</th>
            <th>Dif</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>
          {results.finalStandings.map((team, index) => {
            let rowClass = '';
            if (index < 8) rowClass = 'playoff-direct';

            return (
              <tr key={index} className={rowClass}>
                <td>{team.rank}</td>
                <td>{team.contestantShortName}</td>
                <td>{team.matchesPlayed}</td>
                <td>{team.matchesWon}</td>
                <td>{team.matchesDrawn}</td>
                <td>{team.matchesLost}</td>
                <td>{team.goalsFor}</td>
                <td>{team.goalsAgainst}</td>
                <td>{team.goalDifference}</td>
                <td>{team.points}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}